import { useState } from 'react';
import type { SelectChangeEvent } from '@all-manager/design-system-v2';
import { useSpace } from '../../../../hooks/useSpace';
import { usePermissions } from '../../../../hooks/usePermissions';
import { useGetDocumentTypes } from '../../api/useGetDocumentTypes';
import type { DocumentTypeDatabase } from '../../../../types';

export const CREATE_NEW_VALUE = '__CREATE_NEW__';

export type Props = {
  value?: string | null;
  onChange: (value: string) => void;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  spaceId?: string;
  isAdmin?: boolean;
};

export default function useDocumentTypeSelect(props: Props) {
  const { currentSpace } = useSpace();
  const { isAdmin: storeIsAdmin } = usePermissions();
  const isAdmin = props.isAdmin ?? storeIsAdmin;
  const spaceId = props.spaceId ?? currentSpace?.id;
  const { data: documentTypes = [], isLoading } = useGetDocumentTypes(spaceId);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  function handleOpenCreateModal() {
    if (isAdmin) {
      setIsCreateModalOpen(true);
    }
  }

  function handleSelectChange(event: SelectChangeEvent<string>) {
    const selectedValue = event.target.value;
    if (selectedValue === CREATE_NEW_VALUE) {
      handleOpenCreateModal();
      return;
    }
    props.onChange(selectedValue);
  }

  function handleCloseCreateModal() {
    setIsCreateModalOpen(false);
  }

  function handleTypeCreated(newType: DocumentTypeDatabase) {
    props.onChange(newType.id);
    setIsCreateModalOpen(false);
  }

  return {
    documentTypes,
    isLoading,
    isCreateModalOpen,
    spaceId,
    isAdmin,
    handleOpenCreateModal,
    handleSelectChange,
    handleCloseCreateModal,
    handleTypeCreated,
  };
}

